(function () {
  var root = document.querySelector('[data-zs-global-contact]');
  if (!root || root.getAttribute('data-zs-ready') === 'true') return;
  root.setAttribute('data-zs-ready', 'true');

  var launcher = root.querySelector('[data-zs-global-contact-open]');
  var dialog = root.querySelector('[data-zs-global-contact-dialog]');
  var closeButton = root.querySelector('[data-zs-global-contact-close]');
  var footer = document.querySelector('[data-zt-footer]');
  var activeTrigger = null;

  function focusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function updateMobileOffset() {
    var buybar = document.querySelector('[data-zs-mobile-buybar]:not([hidden])');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var offset = 20;
    if (isMobile && buybar) offset = Math.ceil(buybar.getBoundingClientRect().height) + 14;
    root.style.setProperty('--zs-contact-launcher-bottom', offset + 'px');
  }

  function updateOtherDialogState() {
    var otherDialogOpen = Array.prototype.some.call(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])'), function (candidate) {
      return candidate !== dialog && candidate.getBoundingClientRect().width > 0 && candidate.getBoundingClientRect().height > 0;
    });
    root.classList.toggle('is-obscured', otherDialogOpen);
  }

  function openDialog() {
    if (!dialog) return;
    activeTrigger = launcher;
    root.open = true;
    launcher.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('zs-global-contact-open');
    window.requestAnimationFrame(function () {
      var first = focusableElements(dialog)[0];
      if (first) first.focus();
    });
  }

  function closeDialog() {
    if (!dialog || !root.open) return;
    root.open = false;
    launcher.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('zs-global-contact-open');
    if (activeTrigger) activeTrigger.focus();
    activeTrigger = null;
    updateOtherDialogState();
  }

  if (closeButton) closeButton.addEventListener('click', closeDialog);

  if (dialog) {
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements(dialog);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  root.addEventListener('toggle', function () {
    if (root.open) {
      openDialog();
    } else {
      launcher.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('zs-global-contact-open');
    }
  });

  document.addEventListener('click', function (event) {
    if (root.open && !root.contains(event.target)) closeDialog();
  });

  if (footer && 'IntersectionObserver' in window) {
    var footerObserver = new IntersectionObserver(function (entries) {
      root.classList.toggle('is-footer-visible', Boolean(entries[0] && entries[0].isIntersecting));
    }, { threshold: 0.02 });
    footerObserver.observe(footer);
  }

  document.addEventListener('focusin', function (event) {
    if (root.contains(event.target)) return;
    root.classList.toggle('is-form-active', Boolean(event.target.closest('form')));
  });
  document.addEventListener('focusout', function () {
    window.setTimeout(function () {
      var active = document.activeElement;
      root.classList.toggle('is-form-active', Boolean(active && active.closest && active.closest('form') && !root.contains(active)));
    }, 0);
  });

  var dialogObserver = new MutationObserver(function () {
    updateOtherDialogState();
    updateMobileOffset();
  });
  dialogObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'class'] });

  window.addEventListener('resize', updateMobileOffset, { passive: true });
  window.addEventListener('scroll', updateMobileOffset, { passive: true });
  updateMobileOffset();
  updateOtherDialogState();
})();
